module.exports = __webpack_public_path__ + "static/media/padding.b11312e5.jpg";